export const PATHOGENICITY = "pathogenicity";
export const SOMATIC = "somatic dbs";
export const GERMLINE = "germline dbs";
export const OTHER = "other dbs";
export const FREQ = "frequency dbs";
export const STRUCT = "structural dbs";

// som
const CIVIC = "wustl_civic"; //  "WUSTL CIViC";
const JAX = "jax_ckb"; // JAX CKB;
const COSMIC = "sanger_cosmic_licensed"; // "Sanger Cosmic Licensed";
const HOTSPOTS = "cancer_hotspots"; // "MSK CancerHotspots"; //
const BPORTAL = "cbio_portal"; // "MSK cBioPortal";
const GDC = "nih_gdc"; // "NIH GDC";
const TP53_SOM = "iarc_tp53_somatic"; // "IARC TP53 Somatic";
const ICGC = "icgc_somatic"; // "ICGC ICGC somatic";

// germ
const UNIPROT = "uniprot_variants"; //  "UNIPROT UniProt Variants";
const CLINVAR = "ncbi_clinvar2"; // "NCBI ClinVar2";
const TP53_GERM = "iarc_tp53_germline"; // "IARC TP53 Germline";
const LOVD = "lumc_lovd"; // LUMC LOVD
// const OMIM = "omim";

// freq
const GNOMAD_EX = "gnomad_exomes"; // "Broad gnomAD exomes";
const GNOMAD_GEN = "gnomad_genomes"; // "Broad gnomAD genomes";
const GNOMAD_MIT = "gnomad_mito"; // "Broad gnomAD Mitochondrial";
const KAVIAR = "isb_kaviar3"; // "ISB kaviar3";
const BRAVO = "bravo"; // "UMICH Bravo";
const MITO = "mitomap"; // "CHOP Mitomap";

// other
const DBSNP = "ncbi_dbsnp"; // "NCBI dbSNP";
const GWAS = "gwas"; // "EBI GWAS Catalog";

// SAPHETOR
const USER_ENTRY = "saphetor_pubmeduserentry"; // "Saphetor PubMedUserEntry";
const USER_COMMENT = "saphetor_varsome_comment"; // "Saphetor VarSome Comment";

// CNV
export const NIH_GTEX = "NIH GTEx";
export const CLINGEN_CNV = "NIH ClinGen CNVs";
export const NIH_CLINGEN = "NIH ClinGen";
export const CLINGEN_REGIONS = "NIH ClinGen Regions";

export const NCBI_DBVAR = "NCBI dbVar";
export const CLINVAR_CNV = "NCBI ClinVar CNVs";

export const GNOMAD_STRUCT = "Broad gnomAD structural variants";
export const GENOMES1000 = "1000genomes 1000genomes";
export const BROAD_CNV = "Broad ExacCNV";
export const DGV = "TCAG DGV";
export const SANGER_DECIPHER = "Sanger DECIPHER";

//
const dbMap = {
  [GNOMAD_GEN]: "gnomAD genomes",
  [GNOMAD_EX]: "gnomAD exomes",
  [GNOMAD_MIT]: "gnomAD Mitochondrial",
  [TP53_GERM]: "IARC Germline",
  [TP53_SOM]: "IARC Somatic",
  [GWAS]: "GWAS",
  [CLINVAR]: "ClinVar",
  [MITO]: "Mitomap",
  [COSMIC]: "COSMIC",
  [HOTSPOTS]: "Cancer Hotspots",
  [BPORTAL]: "cBioPortal",
  [CIVIC]: "CIViC",
  [GDC]: "GDC",
  [JAX]: "JAX",
  [UNIPROT]: "UniProt variants",
  [ICGC]: "ICGC Somatic",
  [KAVIAR]: "Kaviar",
  [BRAVO]: "Bravo",
  [DBSNP]: "dbSNP",
  [DGV]: "DGV",
  [CLINVAR_CNV]: "ClinVar CNVs",
  [NCBI_DBVAR]: "NCBI dbVar",
  [CLINGEN_CNV]: "NIH ClinGen CNVs",
  [NIH_CLINGEN]: "NIH ClinGen",
  [CLINGEN_REGIONS]: "NIH ClinGen Regions",
  [GNOMAD_STRUCT]: "Broad gnomAD",
  [GENOMES1000]: "1000 Genomes",
  [BROAD_CNV]: "ExacCNV",
  [USER_ENTRY]: "User-Linked Articles",
  [USER_COMMENT]: "Community Classifications",
  [SANGER_DECIPHER]: "DECIPHER",
  [NIH_GTEX]: "NIH GTEx",
  [LOVD]: "LOVD",
  // [OMIM]: "OMIM ®",
};

const synonyms = {
  "Saphetor PubMedUserEntry": USER_ENTRY,
  "Saphetor VarSome Comment": USER_COMMENT,
  "NCBI ClinVar2": CLINVAR,
  "UNIPROT UniProt Variants": UNIPROT,
  "LUMC LOVD": LOVD,
  "CHOP Mitomap": MITO,
};

export const dbIndex = {};
export const dbLabels = {};

Object.entries(dbMap).forEach(([val, label], i) => {
  dbIndex[val] = i;
  dbLabels[i] = label;
});

Object.entries(synonyms).forEach(([syn, val]) => {
  dbIndex[syn] = dbIndex[val];
});

const pathoDbs = [LOVD, UNIPROT, MITO, USER_ENTRY, USER_COMMENT, CLINVAR];
const somaticDbs = [CIVIC, JAX, ICGC, COSMIC, HOTSPOTS, BPORTAL, GDC, TP53_SOM];
const germlineDbs = [UNIPROT, CLINVAR, TP53_GERM];
const freqDbs = [GNOMAD_EX, GNOMAD_GEN, GNOMAD_MIT, KAVIAR, BRAVO, MITO];
const otherDbs = [DBSNP, GWAS];
const structuralDbs = [
  // ncbi
  NCBI_DBVAR,

  // broad
  GNOMAD_STRUCT,
  BROAD_CNV,
  //
  SANGER_DECIPHER,
  DGV,

  // nih
  NIH_GTEX,
  NIH_CLINGEN,
  CLINGEN_REGIONS,
  CLINGEN_CNV,
  // ncbi
  CLINVAR_CNV,
];

const createDBForCat = (category, all) => (key, ind) => {
  const name = dbMap[key];
  const index = dbIndex[key];
  const categoryIndex = ind;
  const { length: size } = all;
  return {
    name,
    key,
    category,
    index,
    categoryIndex,
    categorySize: size,
  };
};

const somaticDict = somaticDbs
  .map(createDBForCat(SOMATIC, somaticDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

const pathoDict = pathoDbs
  .map(createDBForCat(PATHOGENICITY, pathoDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

const germDict = germlineDbs
  .map(createDBForCat(GERMLINE, germlineDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

const otherDict = otherDbs
  .map(createDBForCat(OTHER, otherDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

const freqDict = freqDbs
  .map(createDBForCat(FREQ, freqDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

const structuralVariantDict = structuralDbs
  .map(createDBForCat(STRUCT, structuralDbs))
  .reduce((a, i) => ({ ...a, [i.key]: i }), {});

export const dbCategories = [FREQ, SOMATIC, GERMLINE, OTHER];

export const variantDbs = { ...somaticDict, ...germDict, ...otherDict };

export const structuralVariantsDbs = { ...structuralVariantDict };

export const frequencyDbs = { ...freqDict };

export const pathogenicityDbs = { ...pathoDict };

export const dbNames = { ...dbMap };
